// Pulled out of usersSlice.ts so this pure date check can be unit-tested
// without pulling in usersSlice's heavy import chain (apiActionCreator ->
// the whole app router -> Firebase init), which fails outside a real app.
export const wasSentInTheLast24Hours = (sentDate: Date | string | null): boolean => {
  const parsedDate = typeof sentDate === 'string' ? new Date(sentDate) : sentDate;
  if (!parsedDate) {
    return false;
  }
  const diffInMs = Date.now() - parsedDate.getTime();
  const diffInHours = diffInMs / (1000 * 60 * 60);
  return diffInHours < 24;
};
